import Swal from "sweetalert2";
import { Link, useMatch } from "react-router-dom";
import { GlobalContext } from "../context/Provider";
import henceforthApi from "../utils/henceforthApi";
import React, { useState, useContext, useEffect } from "react";
import { useParams } from "react-router-dom";
import Profile from "../assets/images/profile_placeholder.png";
import { Spinner } from "../components/BootstrapCompo";
import axios from "axios";
const ReactQuill =
  typeof window === "object" ? require("react-quill") : () => false;

export default () => {
  const match = useMatch("/policies/:id/:type/:edit");
  const { authState, authDispatch } = useContext(GlobalContext);
  henceforthApi.setToken(authState.access_token);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState("")
  const [file, setFile] = useState(null);
  const { type } = useParams();

  const [state, setState] = useState({
    created_at: "",
    image_url: "",
    title: "",
    type: "",
    updated_at: "",
    _id: "",
  });
  const [description, setDesciption] = useState("");
  const [title, setTitle] = useState("");

  const handleUpload = async (file) => {
    setLoading(true);
    const url = `${henceforthApi.API_ROOT}Upload`;
    const formData = new FormData();
    formData.append("file", file);

    const config = {
      headers: {
        "content-type": "multipart/form-data",
        token: authState.access_token,
      },
    };
    const apiRes = await (await axios.post(url, formData, config)).data;

    setFile(apiRes.data.file_name);
    setState({
      ...state,
      image_url: apiRes.data.file_name,
    });
    const data = {
      type: title,
      image_url: apiRes.data.file_name,
      description: description,
      language: "ENGLISH",
    };

    henceforthApi.Policies.addEditPolicy(data)
      .then((res) => {
        setLoading(false);
        // console.log(res);
      })
      .catch((err) => {
        // console.log(err);
        setLoading(false);
      });
  };

  const handleSubmit = (e) => {
    // console.log(file, "file");
    e.preventDefault();
    const data = {
      type: match.params.type,
      description: description,
      title: title,
      language: "ENGLISH",
    };
    if (state.image_url) {
      data["image_url"] = state.image_url;
    }

    henceforthApi.Policies.addEditPolicy(data)
      .then((res) => {
        setLoading(false);
        initialiseData();
        // console.log(res);
        Swal.fire({
          title: "Content updated",
          text: "Content updated successfully",
          icon: "success",
          confirmButtonText: "OK",
          confirmButtonColor: "black"
        });
        window.history.back();
      })
      .catch((err) => {
        // console.log(err);
        setLoading(false);
        Swal.fire({
          title: "Error!",
          text: err.response.body.error_description,
          icon: "error",
          confirmButtonText: "Cancel",
          confirmButtonColor: "black"

        });
      });
  };
  const initialiseData = async () => {
    try {
      let apiRes = await henceforthApi.Policies.Details(match.params.id);
      // let obj =
      //   Array.isArray(apiRes.data.data) && apiRes.data.data.length
      //     ? apiRes.data.data[0]
      //     : apiRes.data.data;
      // setState({
      //   ...state,
      //   ...obj,
      // });
      // console.log(apiRes);
      setData(apiRes)
      setDesciption(apiRes.description);
      setTitle(apiRes.type);
      // console.log(apiRes);
    } catch (error) { }
  };

  useEffect(() => {
    initialiseData();
  }, []);

  const onEditorStateChange = (e) => {
    setDesciption(e);
  };
  // const fileNull = () => {
  //   // console.log("click");
  //   setFile(null);
  // };
  return (
    <div className="animated fadeInRight row">
      <div className="col-md-12">
        <div className="ibox">
          <form onSubmit={(e) => handleSubmit(e)}>
            <div className="ibox-content spinerr-wrapper">
              <div className="form-group">
                <label>
                  <h4>Page Title:</h4>
                </label>
                <input
                  value={match?.params?.type}
                  type="text"
                  placeholder="Enter Page Title"
                  className="form-control"
                // onChange={(e) => setTitle(e.target.value)}
                />
              </div>
              <div className="form-group">
                <label>
                  <h4>Description:</h4>
                </label>
                <div
                  style={{
                    border: "1px solid rgba(0,0,0,.2)",
                    paddingBottom: "20px",
                    background: "white",
                  }}
                >
                  <ReactQuill
                    theme="snow"
                    onChange={(e) => onEditorStateChange(e)}
                    placeholder={`Write your content`}
                    value={description}
                  />
                </div>
              </div>
              <div className="form-group  spinner-inner">
                {/* {loading ? (
                  <div className="position-relative d-inline-block">
                    <img
                      className="profile-user position-relative"
                      alt=""
                      src={
                        state.image_url
                          ? `${henceforthApi.API_FILE_ROOT_MEDIUM}${state.image_url}`
                          : Profile
                      }

                    />
                    <div
                      className={`spinner-border spinner-grow-md spinerrrrr   `}
                      role="status"
                    >
                      <span className="visually-hidden"></span>
                    </div>
                    <label className="label edit-label" for="upload-profile">
                      <i className="fa fa-camera"></i>
                    </label>
                    <input
                      onChange={(e) => handleUpload(e.target.files[0])}
                      type="file"
                      id="upload-profile"
                      className="form-control d-none"
                    />
                  </div>
                ) : (
                  <div className="position-relative d-inline-block">
                    <img
                      className="profile-user"
                      alt=""
                      src={
                        state.image_url
                          ? `${henceforthApi.API_FILE_ROOT_SMALL}${state.image_url}`
                          : Profile
                      }
                    />
                    <label className="label edit-label" for="upload-profile">
                      <i className="fa fa-camera"></i>
                    </label>
                    <input
                      onChange={(e) => handleUpload(e.target.files[0])}
                      type="file"
                      id="upload-profile"
                      className="form-control d-none"
                    />
                  </div>
                )} */}
              </div>
              <div className="form-group text-end">
                <button
                  type="button"
                  className="btn btn-white btn-sm"
                  onClick={() => window.history.back()}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn btn-primary btn-sm ms-2"
                >
                  Save Changes
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};
